<template>
    <div>
        <el-dialog title="反馈详情" width: :visible.sync="commentflag">
            <el-card class="box-card" style="margin-bottom:15px;">
                <div style="margin-bottom:8px;">
                    <el-row style="margin:0 15px;">

                        <el-col :span="24">
                            <el-col :span="12">
                                反馈人:{{infodata.userName}}
                            </el-col>
                            <el-col :span="12">
                                反馈时间:{{times(infodata.createTime)}}
                            </el-col>
                            <el-col :span="24">
                                反馈内容:{{infodata.tips.split('times=')[0]}}
                            </el-col>
                            <el-col :span="24" v-if="infodata.voicePaths>0">
                                <div style="line-height:50px;">
                                    <audio :src="getimgpath(infodata.voicePaths)" controls="controls" style="margin-top:15px;"></audio>
                                </div>
                            </el-col>
                            <el-col :span="24" v-if="imgPathlist.length>0">
                                 <p>现场图片</p>
                                 <div v-for="(item,index) in imgPathlist" :key=index style="float:left;">
                                    <div style="margin-bottom:8px;margin-right:15px;">
                                        <img :src="getimgpath(item)" style="width:200px;"/>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="24" v-if="videoPathlist.lenght>0">
                                 <p>现场视频</p>
                                 <div v-for="(item,index) in videoPathlist" :key=index style="float:left;">
                                    <div style="margin-bottom:8px;margin-right:15px;">
                                       <video :src="getimgpath(item)" controls="controls" style="width: 49%;height:150px;float:left;margin-right:1%;"> </video>
                                    </div>
                                </div>
                            </el-col>
                             <el-col :span="24">
                                 <p>查看过{{infodata.projectFeedbackLogs.length}}人</p>
                                   <div v-for="(item,index) in infodata.projectFeedbackLogs" :key=index style="float:left;">
                                        <img :src="item.avatar?getimgpath(item.avatar):item.headimgurl?item.headimgurl:'/img/default-avatar.png'" style="width:60px;border-radius:50%;"/>
                                </div>
                            </el-col>
                            <el-col :span="3">
                                <img :src="infodata.avatar?getimgpath(infodata.avatar):infodata.headimgurl" style="width:60px;border-radius:50%;"/>
                            </el-col>
                            <!--<el-col :span="21">
                                <el-col :span="3">{{infodata.userName?infodata.userName:'系统'}} </el-col>
                                <el-col :span="6">{{times(infodata.createTime)}} </el-col>
                                <el-col :span="24">
                                    <p style="margin-bottom: 8px;">{{infodata.content}}</p>
                                </el-col>
                            </el-col> -->
                        </el-col>
                    </el-row>
                </div>
            </el-card>
            <el-card class="box-card" v-if="record.length==0" style="margin-bottom:15px;">
                <p style="margin-bottom:8px;margin-left:15px;">暂时没有评论信息</p>
            </el-card>
            <div v-for="(item,index) in record" :key=index class="text item">
                <el-card class="box-card" style="margin-bottom:15px;">
                    <div style="margin-bottom:8px;">
                        <el-row style="margin:0 15px;">
                             <el-col :span="24">
                                <el-col :span="3">
                                    <img :src="item.avatar?getimgpath(item.avatar):(item.headimgurl?item.headimgurl:'/img/default-avatar.png')" style="width:60px;border-radius:50%;"/>
                                </el-col>
                                <el-col :span="21">
                                    <el-col :span="3">{{item.userName?item.userName:'系统'}} </el-col>
                                    <el-col :span="6">{{times(item.createTime)}} </el-col>
                                    <el-col :span="24">
                                        <p style="margin-bottom: 8px;">{{item.content}}</p>
                                    </el-col>
                                </el-col>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <el-form :model="form" ref="form" label-width="100" class="demo-dynamic">
                <el-form-item prop="content" label="评论" :rules="[{ required: true, message: '请输入评论信息', trigger: 'blur' }]" style="margin-bottom:0;">
                    <el-input v-model="form.content"></el-input>
                </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('form')">退出</el-button>
                <el-button type="primary" @click="commentput('form')">评论</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {getComment,insertComment,getrecordinfo} from '@/api/admin/taskManagement'
    import { objKeySort } from '@/util/ajaxsign'
    import { dateOnce } from '@/util/dateT'
    import {getImgLink} from '@/config/env'
    export default {
        components: {},
        data() {
            return {
                commentflag : false,
                serviceType : '',
                serviceId : '',
                infodata : undefined,
                radiorecord : '',
                record : [],
                imgPathlist : [],
                videoPathlist : [],
                state : '',
                form : {
                    content : ''
                }
            }
        },
        created() {},

        methods: {
            //设置展示
             commentstate(serviceId,serviceType){
                 console.log(123456)
                this.serviceType = serviceType;
                this.serviceId = serviceId;
                // this.state = state;
                this.commentflag = true;
                this.getcomment();
                this.getrecordinfo()
            },
            getcomment(){
                getComment(objKeySort({serviceType:this.serviceType,serviceId:this.serviceId})).then(response =>{
                    this.record = response.data.data;
                })
            },
            getrecordinfo(){
                console.log(123456)
                getrecordinfo(objKeySort({id:this.serviceId})).then(response =>{
                    this.infodata = response.data.data;
                    this.imgPathlist = response.data.data.imgPaths?response.data.data.imgPaths.split(','):[];
                    this.videoPathlist = response.data.data.voicePaths?response.data.data.voicePaths.split(','):[];
                })
            },
            //时间转化
            times(data){
                return dateOnce(data)
            },

            //发布评论
            commentput(data){
                console.log(data)
                this.$refs[data].validate((valid) => {
                if (valid) {
                    insertComment(objKeySort({serviceType:this.serviceType,serviceId:this.serviceId,content:this.form.content})).then(response =>{
                        this.getcomment();
                        this.$refs[data].resetFields();
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },

            //图片路径处理
            getimgpath(data){
                return getImgLink(data)
            },

            resetForm(data) {
                this.$refs[data].resetFields();
                this.commentflag = false;
            }

        }
    }
</script>
